export const USER_ID = "user_id";
export const TOKEN = "token";
export const REF = "ref";
export const CHAT_ID = "chat_id";
export const USERNAME = "username";
export const PREMIUM = "is_premium";
export const PRIZE = "prize";
